import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

// Components
import RefundLineItems from "./RefundLineItems";
import RefundShipping from "./RefundShipping";
import RefundReasons from "./RefundReasons";
import RefundSummary from "./RefundSummary";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    textTransform: "none",
  },
  alertBox: {
    marginBottom: theme.spacing(2),
  },
}));

const OrderRefund = ({
  handleClose,
  getImage,
  fulfilledItems,
  unfulfilledItems,
  products,
}) => {
  const classes = useStyles();

  const {
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setValues,
    setErrors,
    setModalStates,
    order,
    refund,
    loading,
    createOrderRefund,
  } = useContext(OrderContext);

  const [fulfilledItems2, setFulfilledItems2] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [btnTotal, setBtnTotal] = useState("0.00");

  const onSubmit = (e) => {
    e.preventDefault();

    // Validation
    let valid = true;

    if (modalErrors.shipping && parseFloat(modalValues.total) <= 0 && !refund) {
      valid = false;
    }

    if (valid) {
      setModalStates({
        submitted: true,
        changed: true,
      });
      createOrderRefund(order.store_name, order.id);
    }
  };

  useEffect(() => {
    if (modalFunction === "refund") {
      // Structure Fulfilled Items - Merge Multiple Fulfillment As One
      let lineItems = {};

      fulfilledItems.map((each) => {
        each.line_items.map((a) => {
          if (a.id in lineItems) {
            let copied = Object.assign({}, lineItems[a.id]);

            copied.quantity = parseInt(copied.quantity + a.quantity);

            lineItems[a.id] = copied;
          } else {
            lineItems[a.id] = a;
          }
        });
      });

      // Total Refunded Quantity of Each Line Item
      const temp_obj = {};

      order.refunds.map((refund) => {
        refund.refund_line_items.map((each) => {
          if (each.line_item_id in temp_obj) {
            temp_obj[each.line_item_id] += each.quantity;
          } else {
            temp_obj[each.line_item_id] = each.quantity;
          }
        });
      });

      // Calculate and Set Fulfillable Quantity
      let arr_lineItems = [];

      Object.values(lineItems).map((item) => {
        if (item.id in temp_obj) {
          item.fulfillable_quantity = item.quantity - temp_obj[item.id];

          if (item.fulfillable_quantity > 0) {
            arr_lineItems.push(item);
          }
        } else {
          arr_lineItems.push(item);
        }
      });

      // setFulfilledItems2(Object.values(lineItems));
      setFulfilledItems2(arr_lineItems);

      // Structure Refund Line Items (Refund Parameter)
      let qtyItems = [];
      let tempIdList = [];

      unfulfilledItems.map((each) => {
        qtyItems.push({
          line_item_id: each.id,
          quantity: 0,
        });
        tempIdList.push(each.id);
      });

      Object.keys(lineItems).map((each) => {
        if (!tempIdList.includes(parseInt(each))) {
          qtyItems.push({
            line_item_id: parseInt(each),
            quantity: 0,
          });
        }
      });

      // Get Total Refunds Amount
      let total_refunds = 0.0;

      if (order.refunds.length > 0) {
        order.refunds.map((refund) => {
          refund.transactions.map((trx) => {
            total_refunds += parseFloat(trx.amount);
          });
        });
      }

      const total_price = order.total_price_set.presentment_money.amount;

      setValues({
        items: qtyItems, // [{line_item_id: "", quantity: ""}]
        shipping: "0.00",
        subtotal: "0.00",
        total: "0.00",
        custom_total: "0.00",
        available_refund: parseFloat(total_price - total_refunds).toFixed(2),
        reasons: "",
        notify_customer: true,
      });
      setErrors({
        shipping: null,
        custom_total: null,
      });
    }
  }, [modalFunction]);

  useEffect(() => {
    let disabled = true;
    let total = "0.00";

    if (!loading && !modalErrors.shipping && !modalErrors.custom_total) {
      if (parseFloat(modalValues.custom_total) > 0) {
        disabled = false;
        total = parseFloat(modalValues.custom_total).toFixed(2);
      } else if (parseFloat(modalValues.total) > 0) {
        disabled = false;
        total = parseFloat(modalValues.total).toFixed(2);
      } else {
        disabled = true;
        total = "0.00";
      }
    }

    setBtnDisabled(disabled);
    setBtnTotal(total);
  }, [modalValues.total, modalValues.custom_total, loading]);

  return (
    modalFunction === "refund" && (
      <Fragment>
        <DialogTitle> Refund </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              {" "}
              {/* Line Items */}{" "}
              {unfulfilledItems.length > 0 && (
                <RefundLineItems
                  type="unfulfilled"
                  lineItems={unfulfilledItems}
                  getImage={getImage}
                  products={products}
                />
              )}{" "}
              {fulfilledItems2.length > 0 && (
                <RefundLineItems
                  type="fulfilled"
                  lineItems={fulfilledItems2}
                  getImage={getImage}
                  products={products}
                />
              )}{" "}
              {unfulfilledItems.length === 0 && fulfilledItems2.length === 0 && (
                <Grid item className={classes.alertBox}>
                  <Alert severity="info">
                    All items in this order have been removed.{" "}
                  </Alert>{" "}
                </Grid>
              )}
              {/* Shiping */}{" "}
              {order.shipping_lines.length > 0 && <RefundShipping />}
              {/* Reasons */} <RefundReasons />
            </Grid>{" "}
            <Grid item xs={4}>
              {" "}
              {/* Summary */} <RefundSummary />
            </Grid>{" "}
          </Grid>{" "}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            disabled={modalStates.submitted ? true : btnDisabled}
          >
            {loading ? "Updating..." : `Refund ${btnTotal}`}{" "}
          </Button>{" "}
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleClose}
            disabled={modalStates.submitted}
          >
            Cancel{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Fragment>
    )
  );
};

export default OrderRefund;
